// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { haveQuestionsStyles } from "@sc/App/Widgets/Cart/HaveQuestions";
import { TRANSLATE_OBJECT } from "@sc/XDL/constants";
import { avoidBreakInsidePrintElement, color } from "@sc/XDL/Utilities";
import { css } from "styled-components";

const sharedSectionTitleStyle: TypographyPresentationProps = {
    css: css`
        font-size: 14px;
        line-height: 22px;
    `,
};

haveQuestionsStyles.wrapperContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
        padding: 17px;
        border: 1px solid ${color("common.border")};
        border-radius: 4px;
        ${avoidBreakInsidePrintElement}
    `,
};

haveQuestionsStyles.title = {
    variant: "h5",
    forwardAs: "p",
    css: css`
        margin-bottom: 0;
    `,
};

haveQuestionsStyles.description = {
    ...sharedSectionTitleStyle,
};

haveQuestionsStyles.personalInfo = {
    infoColumnContainer: {
        css: css`
            display: flex;
            flex-direction: column;
            flex: 1;
        `,
    },
    header: {
        variant: "h6",
        forwardAs: "p",
        css: css`
            margin-bottom: 8px;
        `,
    },
    name: {
        ...sharedSectionTitleStyle,
        css: css`
            margin-bottom: 4px;
        `,
    },
    accountLink: {
        typographyProps: {
            ...sharedSectionTitleStyle,
            ...TRANSLATE_OBJECT as any
        },
        css: css`
            &:not(:last-child) {
                margin-bottom: 4px;
            }
        `,
    },
};
